<template>
    <div class="learn-box">
        <div class="statistics-box">
            <div class="style1">
                <div class="title">教材获取时间</div>
                <div class="text">{{ info.getGoodsTime }}</div>
            </div>
            <div class="style2">
                <div class="title">教材阅读次数</div>
                <div class="text">{{ info.readingCount }}次</div>
            </div>
            <div class="style3">
                <div class="title">教材学习时长</div>
                <div class="text">{{ info.readingTime }}分</div>
            </div>
        </div>
        <!-- <div class="chart-box">
            <div class="model-title">课堂活动统计</div>
            <div class="model-body">
                <div class="left-card">
                    <div id="readChart" style="width: 900px;height: 297px"></div>
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
import * as echarts from 'echarts';
import { GetReadStatistics } from '@/api/user/course'

export default {
    name: 'ReadStatistics',
    props: {
        courseData: {
            type: Object,
            default: {}
        },
        goodInfo: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            option: {
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'horizontal',
                    right: 0,
                    top: '50%'
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        radius: '60%',
                        data: [
                            { value: 0, name: '课堂阅读' },
                            { value: 0, name: '课下阅读' },
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ],
                gird: {
                    show: true,
                }
            },
            info: {},//
        }
    },
    watch: {
        courseData: {
            handler(newval) {
                if (newval.classId) {
                    // this.getInfo()
                }
            }
        }
    },
    mounted() {
        // var chartDom = document.getElementById('readChart');
        // var myChart = echarts.init(chartDom);
        // console.log(myChart);
        setTimeout(() => {
            // myChart.setOption(this.option);
            this.getInfo()
        }, 1000);
    },
    methods: {
        getInfo() {
            GetReadStatistics({
                fileId: this.goodInfo.filesId,
                goodsId: this.goodInfo.goodsId
            }).then(pop => {
                this.info = pop.data
                console.log(this.info);

            })
        }
    }
}
</script>
<style scoped lang='scss'>
.learn-box {
    padding: 0 26px;


    .statistics-box {
        display: flex;
        align-items: center;
        justify-content: space-between;

        >div {
            width: 309px;
            height: 84px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding-left: 30px;

            .title {
                font-family: PingFang SC, PingFang SC;
                font-weight: bold;
                font-size: 18px;
                color: #333333;
            }

            .text {
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #666666;
                margin-top: 13px;
            }
        }

        .style1 {
            background-image: url('../../../../assets/images/style_bg3.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
        }

        .style2 {
            background-image: url('../../../../assets/images/style_bg4.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
        }

        .style3 {
            background-image: url('../../../../assets/images/style_bg5.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
        }

    }

    .chart-box {
        margin-top: 30px;

        .model-title {
            font-family: PingFang SC, PingFang SC;
            font-weight: bold;
            font-size: 16px;
            color: #333333;
        }

        .model-body {
            margin-top: 14px;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            padding-bottom: 1px;

            .left-card {
                width: 100%;
                height: 297px;
                background: #FFFFFF;
                box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.2);
                border-radius: 10px 10px 10px 10px;
            }
        }

    }
}
</style>